'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('document-tree-add-from-archive', {
      url: '/document-tree/add-from-archive',
      template: '<document-tree-add-from-archive></document-tree-add-from-archive>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/document/tree-add-from-archive/document-tree-add-from-archive.routes.js